import script from "./Main-Primevue.vue?vue&type=script&lang=js"
export * from "./Main-Primevue.vue?vue&type=script&lang=js"

import "./Main-Primevue.vue?vue&type=style&index=0&id=3ac95f70&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ac95f70"]])

export default __exports__